var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 268,
    viewBox: "0 0 208 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.834 15.3333H155.917L141.084 0.5H66.917L52.0837 15.3333H0.166992V45H207.834M15.0003 237.833C15.0003 245.701 18.1259 253.247 23.6895 258.811C29.2531 264.374 36.7989 267.5 44.667 267.5H163.334C171.202 267.5 178.748 264.374 184.311 258.811C189.875 253.247 193 245.701 193 237.833V59.8333H15.0003V237.833Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.35a0cfd3d5379ee85e3b016f9bdd3fcb.svg";
export { ForwardRef as ReactComponent };